import type { PendingMessage } from '../optimisticMessages'
import type { ThreadRow } from '../threadTimeline'
import { ThreadDaySeparator } from './ThreadDaySeparator'
import { ThreadUnreadMarker } from './ThreadUnreadMarker'
import { TicketMessageGroup } from './TicketMessageGroup'
import { TicketStatusEvent } from './TicketStatusEvent'

interface PendingMessageHandlers {
  onRetryPending: (pending: PendingMessage) => void
  onDiscardPending: (pending: PendingMessage) => void
}

interface ThreadRowViewProps extends PendingMessageHandlers {
  row: ThreadRow
}

interface ThreadTranscriptProps extends PendingMessageHandlers {
  rows: ThreadRow[]
}

const ThreadRowView = ({
  row,
  onRetryPending,
  onDiscardPending,
}: ThreadRowViewProps) => {
  switch (row.kind) {
    case 'day':
      return <ThreadDaySeparator label={row.label} />
    case 'unread':
      return <ThreadUnreadMarker />
    case 'status':
      return <TicketStatusEvent message={row.message} />
    case 'group':
      return (
        <TicketMessageGroup
          group={row}
          onRetryPending={onRetryPending}
          onDiscardPending={onDiscardPending}
        />
      )
  }
}

export const ThreadTranscript = ({
  rows,
  onRetryPending,
  onDiscardPending,
}: ThreadTranscriptProps) => (
  <>
    {rows.map((row) => (
      <ThreadRowView
        key={row.key}
        row={row}
        onRetryPending={onRetryPending}
        onDiscardPending={onDiscardPending}
      />
    ))}
  </>
)
